import { useNavigate, useParams } from 'react-router-dom'
import { ArrowLeft, Phone } from 'lucide-react'

const QUARTER_LABELS = {
  q12020: 'Q1 2020', q22020: 'Q2 2020', q32020: 'Q3 2020', q42020: 'Q4 2020',
  q12021: 'Q1 2021', q22021: 'Q2 2021', q32021: 'Q3 2021', q42021: 'Q4 2021'
}

export default function BookCallPage() {
  const navigate = useNavigate()
  const { applicationId, quarter } = useParams()
  const quarterLabel = QUARTER_LABELS[quarter] || quarter

  return (
    <div className='w-full min-h-full flex flex-col items-center p-6 pb-16 text-slate-900 dark:text-white transition-colors duration-300'>
      <div className='w-full flex flex-col items-center mt-8'>

        {/* Back Navigation */}
        <button
          onClick={() => navigate(`/applications/${applicationId}/quarter-breakdown`)}
          className='self-start flex items-center gap-2 text-gray-500 hover:text-gray-800 dark:text-slate-400 dark:hover:text-slate-200 transition-colors mb-6 cursor-pointer'
        >
          <ArrowLeft className='w-4 h-4' />
          <span className='text-sm'>Back to Quarter Breakdown</span>
        </button>

        <div className='w-full flex flex-col items-center'>
          {/* Header */}
          <div className='mb-8 text-center'>
            <h1 className='text-3xl font-bold text-gray-900 dark:text-white mb-3'>
              Book IRS Call
            </h1>
            <p className='text-gray-600 dark:text-slate-300'>
              {quarterLabel}
            </p>
          </div>

          {/* Card */}
          <div className='w-full bg-white dark:bg-slate-800 border-2 border-gray-200 dark:border-slate-700 rounded-xl p-8 transition-colors duration-300'>
            <p className='text-lg text-gray-800 dark:text-slate-200 text-center mb-8 font-medium leading-relaxed'>
              To resolve your undelivered refund, you need to schedule a call with the IRS. Click the button below to book your call.
            </p>

            <div className='flex justify-center'>
              <a
                href='https://link.turnkeyfinancial.solutions/call-IRS'
                target='_blank'
                rel='noopener noreferrer'
                className='flex items-center justify-center gap-3 py-4 px-8 bg-ertc-primary hover:bg-orange-600 text-white font-semibold rounded-lg transition-colors cursor-pointer'
              >
                <Phone className='w-5 h-5' />
                Book IRS Call
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
